<form nz-form [formGroup]="form">
  <nz-form-item>
    <nz-form-label [nzSpan]="fromGrid.labelSpan">
      {{ 'COMPANY' | translate }}
    </nz-form-label>
    <nz-form-control [nzSpan]="fromGrid.controlSpan">
      <input nz-input formControlName="company" />
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label [nzSpan]="fromGrid.labelSpan">
      {{ 'MODEL' | translate }}
    </nz-form-label>
    <nz-form-control [nzSpan]="fromGrid.controlSpan">
      <input nz-input formControlName="model" />
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label [nzSpan]="fromGrid.labelSpan">
      {{ 'LOT_INFO.COLOR' | translate }}
    </nz-form-label>
    <nz-form-control [nzSpan]="fromGrid.controlSpan">
      <input nz-input formControlName="color" />
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label [nzSpan]="fromGrid.labelSpan">
      {{ 'LOT_INFO.SCORE' | translate }}
    </nz-form-label>
    <nz-form-control [nzSpan]="fromGrid.controlSpan">
      <input nz-input formControlName="rating" />
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label [nzSpan]="fromGrid.labelSpan">
      {{ 'LOT_INFO.CHASSIS_ID' | translate }}
    </nz-form-label>
    <nz-form-control [nzSpan]="fromGrid.controlSpan">
      <input nz-input formControlName="frame" />
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label [nzSpan]="fromGrid.labelSpan">
      {{ 'LOT_INFO.MILEAGE' | translate }}
    </nz-form-label>
    <nz-form-control [nzSpan]="fromGrid.controlSpan">
      <nz-input-number formControlName="mileage" [nzMin]="0" [nzStep]="1"></nz-input-number>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label [nzSpan]="fromGrid.labelSpan">
      {{ 'MODEL_GRADE' | translate }}
    </nz-form-label>
    <nz-form-control [nzSpan]="fromGrid.controlSpan">
      <input nz-input formControlName="grade" />
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label [nzSpan]="fromGrid.labelSpan">
      {{ 'LOT_INFO.YEAR' | translate }}
    </nz-form-label>
    <nz-form-control [nzSpan]="fromGrid.controlSpan">
      <nz-input-number formControlName="year" [nzMin]="1885" [nzStep]="1"></nz-input-number>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label [nzSpan]="fromGrid.labelSpan">
      {{ 'ENGINE_VOLUME' | translate }}
    </nz-form-label>
    <nz-form-control [nzSpan]="fromGrid.controlSpan">
      <nz-input-number formControlName="engineVolume" [nzMin]="0" [nzStep]="100"></nz-input-number>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label [nzSpan]="fromGrid.labelSpan">
      {{ 'TRANSMISSION' | translate }}
    </nz-form-label>
    <nz-form-control [nzSpan]="fromGrid.controlSpan">
      <input nz-input formControlName="transmission" />
    </nz-form-control>
  </nz-form-item>
</form>

<ng-container *nzModalFooter>
  <button nz-button nzType="primary" [nzLoading]="saving$ | async" (click)="submit()">
    {{ 'SAVE' | translate }}
  </button>
  <button nz-button [disabled]="saving$ | async" (click)="close()">
    {{ 'CANCEL' | translate }}
  </button>
</ng-container>
